import React from 'react';
import { Container } from 'reactstrap';
import { PrimaryButton, SecondaryButton } from '../common/Buttons';
import './style.css';

function CallToActionSection({ id }) {
  return (
    <section
      id={id || "schedule-call"}
      className="cta-section"
    >
      <Container>
        <div className="cta-inner">
          <h2 className="cta-title">
            Ready to grow without worrying about hosting?
          </h2>
          <div className="cta-buttons">
            <PrimaryButton href="/hosting#plans">
              🚀 Choose Hosting Plan
            </PrimaryButton>
            <SecondaryButton href="/Net-30">
              💳 Request NET 30
            </SecondaryButton>
            <SecondaryButton href="/contact">
              📞 Schedule a Call
            </SecondaryButton>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default CallToActionSection;
